module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_DoubleUp_16"],"path":[{"$":{"d":"M12.76,15.16,8,10l-4.76,5.2L1.76,13.8,8,7l6.24,6.8Zm1.47-7.7L8,.65,1.76,7.45,3.24,8.8,8,3.61l4.76,5.2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_DoubleUp_16.svg
// module id = o+ME
// module chunks = 1